<template>
  <SubSidebarLayout :menu-categories="menuCategories" />
</template>
<script>
import SubSidebarLayout from '@/components/sidebars/SubSidebarLayout'

export default {
  components: {
    SubSidebarLayout
  },
  data: () => ({
    menuCategories: [
      {
        name: 'ログインユーザー',
        items: [
          {
            text: '管理者',
            situation: 'admin_management',
            router: { name: 'adminAdminUsers' }
          },
          {
            text: 'ライター',
            situation: 'writer_management',
            router: { name: 'adminWriters' }
          }
        ]
      },
      {
        name: '外部ユーザー',
        items: [
          {
            text: '監修者',
            situation: 'expert_management',
            router: { name: 'adminExperts' }
          },
          {
            text: '寄稿者',
            situation: 'contributor_management',
            router: { name: 'adminContributors' }
          }
        ]
      },
      {
        name: 'ユーザー別レポート',
        items: [
          {
            text: '月次レポート',
            situation: 'order_management',
            router: { name: 'adminWriterMonthlyReport' }
          }
        ]
      }
    ]
  })
}
</script>
